import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { isUndefined } from 'util';

@Component({
  selector: 'nec-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss']
})
export class NecSearchComponent implements OnInit {

  @Input() placeholderText: string;

  /**
   * æ¯å¦æ¾ç¤ºæ¢ç´¢æé®
   */
  @Input() showSearchBtn?: boolean;

  @Input() searchText?: string;

  @Input() btnText?: string;

  @Output() instantChange = new EventEmitter();

  @Output() searchTextChange = new EventEmitter();

  ngOnInit() {
    if (isUndefined(this.searchText)) {
      this.searchText = '';
    }
    if (isUndefined(this.placeholderText)) {
      this.placeholderText = '';
    }
  }

  searchKeyPress(event) {
    if (event.charCode === 13) {
      this.search();
    }
  }

  search() {
    this.searchText = this.searchText || '';
    this.searchTextChange.emit(this.searchText.trim());
  }

  clear() {
    this.searchText = '';
    this.search();
    this.instantSearch();
  }

  // å³æ¶æç´¢ï¼å¯ä»¥èèç¨ObservableçflatMapLatestæä½ç¬¦ä¼å
  instantSearch() {
    this.searchText = this.searchText || '';
    this.instantChange.emit(this.searchText.trim());
  }
}
